import axios from 'axios';
import { Dispatch, SetStateAction, useState } from 'react';
import ReactCodeInput from 'react-code-input';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../app/hooks';
import Spinner from '../../components/common/Spinner';
import {
  ErrorToast,
  SuccessToast
} from '../../components/common/Toasts/Toasts';
import { P2, P3 } from '../../styles/FontStyles';
import {
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';
import { confirm2FAEmail } from './Settings.actions';

export const TwoFAEmail = ({
  setIsOpen
}: {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const [code, setCode] = useState('');
  const [loadingCode, setLoadingCode] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const { loadingVerification } = useAppSelector((state) => state.settings);
  const { user } = useAppSelector((state) => state.auth.userInfo);

  const sendCode = async () => {
    try {
      setLoadingCode(true);
      await axios.post(
        `/user/settings/security/signin/email-verification/enable/code`
      );

      setLoadingCode(false);
      SuccessToast(t('email.code_sent'));
      setIsCodeSent(true);
    } catch (error: any) {
      ErrorToast(error.response.data.error);
      setLoadingCode(false);
    }
  };

  const onHandleSubmit = (e: any) => {
    e.preventDefault();
    dispatch(confirm2FAEmail({ code, setIsOpen }));
  };

  return (
    <>
      {loadingCode || loadingVerification ? (
        <Spinner />
      ) : (
        <>
          <form onSubmit={onHandleSubmit}>
            <Flexed between>
              <P2 bold color={color.colors.neutral700}>
                {t('email.email_code')}
              </P2>
              <P2
                bold
                style={{ cursor: 'pointer' }}
                color={color.colors.primary900}
                onClick={() => sendCode()}>
                {t('email.send_code')}
              </P2>
            </Flexed>
            <SecurityCodeWrapper>
              <ReactCodeInput
                name='email code input'
                inputMode='numeric'
                fields={7}
                value={code}
                onChange={setCode}
                type={'number'}
              />
            </SecurityCodeWrapper>
            <P3 color={color.colors.neutral500} mb='40'>
              {isCodeSent && `Enter the 7 digit code sent to ${user?.email}`}
            </P3>

            <Button m='30px 0 10px 0' disabled={code === '' ? true : false}>
              {t('security.enable')}
            </Button>
          </form>
        </>
      )}
    </>
  );
};
